export function addCancelButtonToForm() {
  $('.gform_wrapper .gform_footer input.button').before(
    '<input type="reset" class="reset-button gform_button button" value="Cancel">'
  );
}



// WEBPACK FOOTER //
// ./scripts/util/helpers.js